module.exports = __webpack_public_path__ + "img/linkedin.33bbef6a.png";